__turbopack_context__.v({
  "logo": "styles-module-scss-module__ie-7oa__logo",
});
